import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/CartaProducto.module.scss'
import { useContextoGlobal } from '../ContextoGlobal';

export const CartaProducto = ({ producto, className, idCarta }) => {
    const { imagen, nombre, url, precio, precioOferta, precioRegular, descuento, on_sale } = producto;
    const { agregarItemsCarrito } = useContextoGlobal();
    
    const agregarAlCarrito = (e) => {
        e.preventDefault();
        e.stopPropagation();
        agregarItemsCarrito(producto);
      };

    return (
        <a href={url} className={'text-decoration-none text-black '}>
            <div id={idCarta} className={styles.producto + ' mx-3 ' + className}>
                <div className={styles.contImagen + ' mb-2'}>
                    <img src={imagen} className={styles.imagen} />
                    {on_sale ? <div className={styles.descuento} >
                        <div className={styles.porcentajeDescuento}>
                            {descuento + '%'}
                        </div>
                    </div>
                        :
                        <></>
                    }
                </div>
                <div className={styles.contDescripcion}>
                    <p className={styles.nombre + ' mb-2'}>{nombre}</p>
                    <p className={styles.precioOferta}>{'$' + precio}</p>
                    {on_sale ? <p className={styles.precio}>{'$' + precioRegular}</p> : <></>}
                    <div className='d-block mt-2'>
                        <img src={images.icons.estrellaLlena} />
                        <img src={images.icons.estrellaLlena} />
                        <img src={images.icons.estrellaLlena} />
                        <img src={images.icons.estrellaLlena} />
                        <img src={images.icons.estrellaVacia} />
                    </div>
                    <img src={images.icons.agregarProducto} className={styles.añadir} onClick={agregarAlCarrito} />
                </div>
            </div>
        </a>
    )

}
